import { useState, useEffect } from 'react';

/**
 * Dark mode: volgt de systeeminstelling (prefers-color-scheme) totdat de
 * gebruiker expliciet kiest via de toggle — pas dán wordt de keuze bewaard.
 * (Voorheen werd ook de systeem-afgeleide waarde direct gepersisteerd,
 * waardoor het thema na het eerste bezoek nooit meer met het systeem meeging.)
 */
export const useDarkMode = () => {
  const [isDark, setIsDarkState] = useState(() => {
    try {
      const stored = localStorage.getItem('lm_dark_mode');
      if (stored !== null) return stored === 'true';
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    } catch { return false; }
  });

  // Zolang er geen expliciete keuze is: systeem-wijzigingen live volgen
  useEffect(() => {
    try {
      if (localStorage.getItem('lm_dark_mode') !== null) return undefined;
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      const onChange = (e) => setIsDarkState(e.matches);
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    } catch { return undefined; }
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  // Toggle = expliciete gebruikerskeuze -> persistent
  const setIsDark = (v) => {
    setIsDarkState((prev) => {
      const next = typeof v === 'function' ? v(prev) : v;
      try { localStorage.setItem('lm_dark_mode', String(next)); } catch { /* private mode */ }
      return next;
    });
  };

  return [isDark, setIsDark];
};
